import {
  ATBeaconButton,
  ATBeaconModal,
} from 'components/common/beacon/beaconRegistration';
import React, { useEffect } from 'react';
import { dispatchOverlayLoad } from 'utils/analyticsUtil';
import { CTAVariants } from '@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant';

interface ExitModalProps {
  open: boolean;
  onClose: () => void;
  onCancel: () => void;
}

const ExitModal: React.FC<ExitModalProps> = ({ open, onClose, onCancel }) => {
  useEffect(() => {
    if (open) {
      dispatchOverlayLoad('Are you sure you want to leave?');
    }
  }, [open]);
  return (
    <div className="beacon-on-light">
      <ATBeaconModal open={open} id="validation-modal" onBeaconEventClose={onClose}>
        <div className="b-typography-serif--headline--200 b-font-weight-bold">
          Are you sure you want to leave?
        </div>
        <div className="b-typography-sans-serif--body--200 b-font-weight-light b-padding-block-start--micro--normal">
          Your information will not be saved.
        </div>
        <div slot="action-zone" className="action-zone-align-right">
          <ATBeaconButton
            slot="close-button-text"
            variant={CTAVariants.Tertiary}
            onBeaconEventClick={onClose}
          >
            Stay On This Page
          </ATBeaconButton>
          <ATBeaconButton
            slot="close-button-text"
            variant={CTAVariants.Primary}
            onBeaconEventClick={onCancel}
          >
            {'Yes Leave This Page'}
          </ATBeaconButton>
        </div>
      </ATBeaconModal>
    </div>
  );
};

export default ExitModal;
